import { IAplosApiRequestArgs } from "@/services/aplosApi";

export interface GetAplosFileArgsOptions {
    tenantId: string;
    userId: string;
    fileId: string;
}

export class GetAplosFileArgs implements IAplosApiRequestArgs {

    public tenantId: string;
    public userId: string;
    public fileId: string;

    constructor(options: GetAplosFileArgsOptions) {
        if (options.tenantId == null) throw Error("tenantId is required");
        if (options.userId == null) throw Error("userId is required");
        if (options.fileId == null) throw Error("fileId is required");

        this.tenantId = options.tenantId;
        this.userId = options.userId;
        this.fileId = options.fileId;
    }

}